import React from 'react';
import { ClickableSuggestion } from '../types';

interface WelcomeScreenProps {
  welcomeMessage: string;
  suggestions: ClickableSuggestion[];
  onSuggestionClick: (suggestion: ClickableSuggestion) => void;
}

const WelcomeScreen: React.FC<WelcomeScreenProps> = ({ welcomeMessage, suggestions, onSuggestionClick }) => {
  if (!welcomeMessage) return null;

  return (
    <>
      <div className="flex gap-2.5 mb-3 fade-up">
        <div className="w-7 h-7 bg-slate-800 rounded-lg flex items-center justify-center shrink-0 mt-0.5">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
        </div>
        <div className="flex-1 min-w-0">
          <div className="bg-slate-50 px-3.5 py-2.5 rounded-2xl rounded-tl-md max-w-[90%]">
            <p className="text-[13px] text-slate-700 leading-relaxed text-left">{welcomeMessage}</p>
          </div>
        </div>
      </div>

      {suggestions.length > 0 && (
        <div className="flex gap-2.5 mb-3">
          <div className="w-7 shrink-0" />
          <div className="flex flex-wrap gap-1.5">
            {suggestions.map((suggestion) => (
              <button
                key={suggestion.id}
                onClick={() => onSuggestionClick(suggestion)}
                className="px-3 py-1.5 bg-white border border-slate-200 text-slate-600 text-[11px] font-medium rounded-lg hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200 transition-all"
              >
                {suggestion.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default React.memo(WelcomeScreen);
